'use client'

import {FC} from 'react'

import {BreadcrumbStep} from '@/app/lib/structuredData'
import {ClassAssistIndustryPage} from '@/components/class-assist/industry/ClassAssistIndustryPage'
import {
  ClassAssistIndustryOverview,
  ClassAssistSectorOverview,
  PopularIndustriesSector,
} from '@/utils/class-assist/types'
import {RecentArticleCard} from '@/utils/contentful'

type ClassAssistIndustrySectorProps = {
  breadcrumbTrail: BreadcrumbStep[] | null
  articles: RecentArticleCard[]
  industry: null | ClassAssistIndustryOverview
  sector: null | ClassAssistSectorOverview
  industryOptions: {value: string; label: string}[]
  sectorOptions: {value: string; label: string}[]
  popularSectors: PopularIndustriesSector[]
}

const ClassAssistIndustrySector: FC<ClassAssistIndustrySectorProps> = ({
  breadcrumbTrail,
  industry,
  sector,
  industryOptions,
  sectorOptions,
  articles,
  popularSectors,
}) => (
  <ClassAssistIndustryPage
    breadcrumbTrail={breadcrumbTrail}
    industryOptions={industryOptions}
    sectorOptions={sectorOptions}
    industry={industry}
    sector={sector}
    articles={articles}
    popularSectors={popularSectors}
  />
)

export default ClassAssistIndustrySector
